"use client"

import styled from "styled-components"
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts"
import {
  Card,
  CardHeader,
  Subtitle,
  Title,
  TitleGroup,
} from "./primitives"

const rev = [
  { q: "Q1", revenue: 90, income: 21 },
  { q: "Q2", revenue: 94, income: 23 },
  { q: "Q3", revenue: 89, income: 20 },
  { q: "Q4", revenue: 119, income: 34 },
]

const ChartWrap = styled.div`
  margin-top: 1rem;
  height: 9rem;
  width: 100%;
`

const ratios = [
  { label: "Gross margin", value: "46.2%" },
  { label: "Operating margin", value: "31.5%" },
  { label: "ROE", value: "148%" },
  { label: "Debt / equity", value: "1.87" },
]

const RatioGrid = styled.div`
  margin-top: 1.25rem;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.625rem;
`

const RatioCell = styled.div`
  border-radius: 1rem;
  background: color-mix(in oklch, var(--color-muted) 50%, transparent);
  border: 1px solid color-mix(in oklch, var(--color-border) 50%, transparent);
  padding: 0.75rem 0.875rem;
`

const RatioLabel = styled.p`
  margin: 0;
  font-size: 0.75rem;
  color: var(--color-muted-foreground);
`

const RatioValue = styled.p`
  margin: 0.25rem 0 0;
  font-family: var(--font-mono);
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-card-foreground);
`

export function RevenueCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Revenue &amp; net income</Title>
          <Subtitle>Trailing four quarters · $B</Subtitle>
        </TitleGroup>
      </CardHeader>

      <ChartWrap>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={rev} margin={{ top: 8, right: 4, bottom: 0, left: 4 }} barGap={4}>
            <XAxis
              dataKey="q"
              tickLine={false}
              axisLine={false}
              tick={{ fill: "var(--color-muted-foreground)", fontSize: 11 }}
              dy={6}
            />
            <Tooltip
              cursor={{ fill: "color-mix(in oklch, var(--color-muted) 60%, transparent)" }}
              contentStyle={{
                borderRadius: "0.75rem",
                border: "1px solid var(--color-border)",
                fontSize: "0.75rem",
                fontFamily: "var(--font-mono)",
              }}
            />
            <Legend
              iconType="circle"
              iconSize={8}
              wrapperStyle={{ fontSize: "0.75rem", color: "var(--color-muted-foreground)" }}
            />
            <Bar dataKey="revenue" name="Revenue" fill="var(--color-optimal)" radius={[4, 4, 0, 0]} isAnimationActive={false} />
            <Bar dataKey="income" name="Net income" fill="var(--color-caution)" radius={[4, 4, 0, 0]} isAnimationActive={false} />
          </BarChart>
        </ResponsiveContainer>
      </ChartWrap>
    </Card>
  )
}

export function KeyRatiosCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Key ratios</Title>
          <Subtitle>Most recent fiscal year</Subtitle>
        </TitleGroup>
      </CardHeader>

      <RatioGrid>
        {ratios.map((r) => (
          <RatioCell key={r.label}>
            <RatioLabel>{r.label}</RatioLabel>
            <RatioValue>{r.value}</RatioValue>
          </RatioCell>
        ))}
      </RatioGrid>
    </Card>
  )
}

export default function FinancialCards() {
  return (
    <div style={{ display: "grid", gap: "1rem" }}>
      <RevenueCard />
      <KeyRatiosCard />
    </div>
  )
}
